/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Signup_Compare_Questions_DayInputs */



/**
* | output |
* | --- |
* | "{count} questions/day" |
*
* @param {Signup_Compare_Questions_DayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_questions_day = /** @type {((inputs: Signup_Compare_Questions_DayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Questions_DayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} questions/day`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} questions/day`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} questions/day`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} questions/day`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} questions/day`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} questions/day`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} questions/day`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} questions/day`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} questions/day`)
	return /** @type {LocalizedString} */ (`${i?.count} questions/day`)
});